import colors from "styles/Colors";
import { tokens } from "styles/Tokens";

export const userTypes = {
  HOTEL_USER: "HOTEL_USER",
  ABOVE_PROPERTY: "ABOVE_PROPERTY",
  CORPORATE: "CORPORATE",
  CONSULTANT: "CONSULTANT",
  LEADERSHIP: "LEADERSHIP"
};

export const planTypes = {
  AllPlans: "AllPlans",
  MyPlans: "MyPlans",
  MulipleAssign: "Mulitple Assign"
};

export const responseTypes = {
  success: 200,
  created: 201,
  accepted: 202,
  no_content: 204,
  partial_content: 206,
  deleted: 207,
  success_threshold: 300,
  error: 400,
  unauthorized: 401,
  forbidden: 403,
  not_found: 404,
  internal_error: 500,
  other_error: 600
};

export const responseStatusTypes = {
  error: "error",
  success: "success",
  warning: "warning"
};

export const formTypes = {
  CreatePlan: "Create",
  CreatePlanFromDashboard: "CreatePlanFromDashboard",
  EditPlan: "Edit"
};

export const pageNames = {
  allPlans: 0,
  bookmarked: 1,
  suggested: 3,
  myPlans: 4,
  noActivePlans: 5,
  noAssignAction: 6,
  noReports: 7,
  noSuggestedFilter: 8,
  functionalArea: 9,
  searchResult: 10,
  searchResultAction: 11,
  globalSearchResult: 12,
  innCodePlans: 13,
  aboveProperty: 14,
  abovePropertyPlans: 15
};

export const serviceTypes = {
  recommendation: "recommendation",
  userplan: "userplan",
  user: "user",
  notification: "notification",
  library: "library",
  gateWay: "gateway-service",
  feedback: "feedback"
};

export const engagementTypes = {
  active: "Active",
  overdue: "Overdue",
  inactive: "Inactive"
};

export const tableExpandedValues: { [key: string]: string } = {
  new: tokens.Text.General.Tertiary,
  inprogress: tokens.Text.Feedback.Progress,
  completed: colors.Green.Green500,
  overdue: colors.Orange.Orange500,
  notstarted: tokens.Text.General.Tertiary,
  active: tokens.Text.Feedback.Done,
  inactive: tokens.Text.Feedback.Neutral
};

export const leftNavItems = {
  dashboard: "Dashboard",
  myDashboard: "My Dashboard",
  corporateDashboard: "Corporate Dashboard",
  impersonateUser: "Impersonate User",
  library: "Library",
  inncodePlans: "Inncode Plans",
  myPlans: "My Plans",
  manageSuggestions: "Manage Suggestions",
  myLists: "My Lists",
  adminConsole: "Admin Console",
  home: "Home",
  feedback: "Manage Feedback"
};

export const consultantEngagementTypes = {
  high: "High",
  medium: "Medium",
  low: "Low"
};

export const recommendationAccessTypes = {
  disabled: "Disabled",
  view: "View",
  edit: "Edit",
  upload: "Upload",
  download: "Download"
};

export const feedbackQuestionCategoryTypes = {
  Rating: 1,
  "Open Text": 2,
  "Radio Button": 3,
  Checkbox: 4
};

export const feedbackTypes = {
  PlanCompleted: "Plan Completed",
  DeletePlan: "Delete Plan",
  LeavePlan: "Leave Plan",
  RemoveSuggestions: "Remove Suggestions"
};

export const apiFailureMessageTypes = {
  500: "Failed to load data due to unexpected error. Please try to",
  400: "Failed to load data due to unexpected error."
};
